import { StrictMode } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Layout } from "./Layout/layout";
import { ChakraProvider, VStack } from "@chakra-ui/react";
import { MenuContentFactory } from "./Layout/menuContentFactory";
import { Home } from "./Home";
import { GlobalProvider } from "./Layout/GlobalState";
import { Participants } from "./Participants";
import { Startgroups } from "./Startgroups";
import { SetStarttime } from "./SetStarttime";
import { Results } from "./Results";
import { Reports } from "./Reports/Reports";
import RegisterBibs from "./RegisterBibs";
import FinishList from "./FinishList";
import TagreadsList from "./TagreadsList";
import { DisciplineStartgroupMap } from "./DisciplineStartgroupMapComponent";
import { Lotteries } from "./Lotteries";
import { ResultRptLists } from "./ResultRptLists";
import LiveResults from "./LiveResults";
import { SetStarttimePhone } from "./SetStarttimePhone";
import TagreadsResend from "./TagreadsResend";

const menuContentFactory = new MenuContentFactory("Stadsloppet");

menuContentFactory.addLink("Home", ".");
menuContentFactory.addLink("Anmälda", "participants");
menuContentFactory.addLink("Resultat", "results");
menuContentFactory.addLink("Rapporter", "reports");

menuContentFactory.addGroup("Tävlingar");
menuContentFactory.addLinkToGroup("Tävlingar", "Lästa taggar", "tag-reads");
menuContentFactory.addLinkToGroup("Tävlingar", "Live resultat", "live-results");
menuContentFactory.addLinkToGroup("Tävlingar", "Målgångslista", "finish-list");
menuContentFactory.addLinkToGroup("Tävlingar", "Startklocka", "set-start-time");
menuContentFactory.addLinkToGroup("Tävlingar", "Startklocka mobil", "set-start-time-mobile");
menuContentFactory.addLinkToGroup("Tävlingar", "Lotta priser", "lotteries");
menuContentFactory.addLinkToGroup("Tävlingar", "Konfigurera Resultatlistor", "result-rpt-lists");
menuContentFactory.addLinkToGroup("Tävlingar", "----------", undefined);
menuContentFactory.addLinkToGroup("Tävlingar", "Registrera taggar", "register-bibs");
menuContentFactory.addLinkToGroup("Tävlingar", "Startgrupper", "startgroups");
menuContentFactory.addLinkToGroup("Tävlingar", "Klass-Startgrupp mappning", "discipline-startgroup-mapping");
menuContentFactory.addLinkToGroup("Tävlingar", "--- TEST ---", undefined);
menuContentFactory.addLinkToGroup("Tävlingar", "Skicka om tagreads", "tag-reads-resend");

const containter = document.getElementById("root");
const root = createRoot(containter!);

root.render(
  <StrictMode>
    <ChakraProvider>
      <GlobalProvider>
        <HashRouter>
          <Routes>
            <Route
              path="/"
              element={<Layout {...menuContentFactory.build()} />}
            >
              <Route index element={<Home />} />
              <Route path="participants" element={<Participants />}></Route>
              <Route path="results" element={<Results />}></Route>
              <Route path="reports" element={<Reports />} />
              <Route path="finish-list" element={<FinishList />} />
              <Route path="set-start-time" element={<SetStarttime />} />
              <Route
                path="set-start-time-mobile"
                element={<SetStarttimePhone />}
              />
              <Route path="live-results" element={<LiveResults />} />
              <Route path="startgroups" element={<Startgroups />} />
              <Route path="lotteries" element={<Lotteries />} />
              <Route path="result-rpt-lists" element={<ResultRptLists />} />
              <Route
                path="discipline-startgroup-mapping"
                element={<DisciplineStartgroupMap />}
              />
              <Route path="register-bibs" element={<RegisterBibs />} />
              <Route path="tag-reads" element={<TagreadsList />} />
              <Route path="tag-reads-resend" element={<TagreadsResend />} />
            </Route>
          </Routes>
        </HashRouter>
      </GlobalProvider>
    </ChakraProvider>
  </StrictMode>
);

function DummyComponent(props: { color: string }) {
  return (
    <>
      <VStack background={props.color}>
        <div>FooBar</div>
        <div>BarFoo</div>
      </VStack>
    </>
  );
}
